<!-- eslint-disable vue/valid-template-root -->
<!-- eslint-disable prettier/prettier -->

<template>
  <div class="container-verify">
    <div class="breakpoint-verify">
      <div class="d-flex justify-center">
        <img
          src="../../assets/img/logo-hara.png"
          height="100px"
          alt="logo-temanbakat"
        />
      </div>
      <p class="text-center title_verify">Verifikasi Tanda Tangan Elektronik</p>
      <p class="text-center _verify">
        PT Hara Anargya Indonesia menyatakan bahwa :
      </p>
      <v-card class="pa-7 rounded-lg" elevation="1">
        <div>
          <p class="mb-0 small_txt">Nama Dokumen :</p>
          <p class="font-weight-bold">
            employeereport_operator_63473-jhorgi putra setiawan.pdf
          </p>
        </div>
        <div>
          <p class="mb-0 small_txt">Disahkan pada tanggal :</p>
          <p class="font-weight-bold">1 November 2022</p>
        </div>
        <p class="mb-0 small_txt">Verifikator:</p>
        <v-card class="pa-3 d-flex align-center" flat color="#fafafa">
          <v-avatar size="56">
            <img src="../../assets/img/logo-hara.png" alt="logo-temanbakat" />
          </v-avatar>
          <div class="ml-3">
            <p class="mb-0 font-weight-bold">Tim Psikolog Hara Anargya</p>
          </div>
        </v-card>
        <div class="py-2">
          <v-divider></v-divider>
        </div>
        <v-card outlined class="pa-3">
          <v-row>
            <v-col cols="6">
              <p class="mb-0 small_txt">Kode Event :</p>
              <p class="mb-0 font-weight-bold">TAP131022</p>
            </v-col>
            <v-col cols="6">
              <p class="mb-0 small_txt">No Tes :</p>
              <p class="mb-0 font-weight-bold">63499</p>
            </v-col>
            <v-col cols="6">
              <p class="mb-0 small_txt">Nama Peserta :</p>
              <p class="mb-0 font-weight-bold">Jhorgi Putra Setiawan</p>
            </v-col>
            <v-col cols="6">
              <p class="mb-0 mb-0 small_txt">Tanggal Tes :</p>
              <p class="font-weight-bold">2022-10-13 09:03:50</p>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifyEsignature",
};
</script>

<style scoped>
.title_verify {
  font-size: 25px;
}
.container-verify {
  width: 100%;
  display: flex;
  justify-content: center;
}
.breakpoint-verify {
  padding: 30px 30px;
  width: 55%;
}
@media (max-width: 576px) {
  .breakpoint-verify {
    width: 100%;
    min-height: 100vh;
  }
}
</style>
